import { defineSchema } from '../../schema-meta.ts';
import { registerSchema } from '../../generic-codec.ts';

export const ValhallaWaveSchema = defineSchema({
  name: 'valhallaWave',
  fields: [
    ['waveNumber', 'number'],
    ['reward', { kind: 'dict', dict: 'delivery' }],
    ['killGoal', 'number?'],
    ['timeLimitSeconds', 'number?'],
    ['silverReward', 'number?'],
    ['shopConfigId', 'number?'],
    ['enemies', { kind: 'array', of: 'stageWaveEnemy' }],
  ],
  lookupKeys: ['waveNumber'],
});

registerSchema(ValhallaWaveSchema);
